import {
    LAWFIRMS
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case LAWFIRMS:
        return action.payload
      default:
        return state
    }
  }